import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";

const comparisonRules = [
  "料金・条件は各社の公式サイトを確認し、確認日と参照先を掲載します。",
  "通常月額と必要な通話料金を合計し、期間限定キャンペーンや端末代とは分けます。",
  "店頭相談を希望する場合は、対面で相談できる通信会社を優先します。",
  "同じブランドに偏らないよう、診断結果は最大3ブランドまで表示します。",
  "特定の通信会社や購入方法が、すべての人に最適だと断定しません。",
];

export default function Policy() {
  return (
    <Layout>
      <section className="border-b border-background-300 bg-background-200">
        <div className="mx-auto max-w-[900px] px-4 md:px-6 py-10 md:py-14">
          <div className="text-xs text-secondary-600 font-semibold tracking-widest">編集方針・免責事項</div>
          <h1 className="mt-2 text-2xl md:text-3xl font-bold text-foreground-900">比較の基準と、情報をご利用いただく際のお願い</h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-7">候補の選び方、情報の確認方法、広告との関係を明らかにします。</p>
        </div>
      </section>

      <section className="mx-auto max-w-[900px] px-4 md:px-6 py-12 space-y-10 text-[15px] text-foreground-700 leading-8">
        <div>
          <h2 className="text-xl font-bold text-foreground-900">比較・診断の方針</h2>
          <ul className="mt-4 space-y-2">
            {comparisonRules.map((rule) => <li key={rule} className="flex gap-2"><i className="ri-check-line text-secondary-500 mt-1.5" />{rule}</li>)}
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground-900">料金診断が見ている条件</h2>
          <p className="mt-3">診断では、毎月のデータ量、電話の使い方、店頭相談の希望から候補を整理します。端末代や現在の端末残債は含めず、「必ず月いくら安くなる」といった節約額は表示しません。</p>
          <p className="mt-3">データ量が分からない場合は月20GBとして仮置きします。30日単位のトッピングや通信速度で選ぶ特殊なプランは診断対象から外し、比較ページで確認できるようにしています。</p>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground-900">情報の確認と更新</h2>
          <p className="mt-3">料金、割引、受付状況、サポート条件は変更されることがあります。掲載時には公式情報を確認していますが、申し込み前には必ずリンク先の公式サイトで最新条件、対応端末、利用地域をご確認ください。</p>
          <p className="mt-3">受付終了プランを掲載する場合は、現在の契約を見直すための参考情報として扱い、新規に申し込めるプランと区別します。</p>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground-900">広告・リンクについて</h2>
          <p className="mt-3">一部の記事と料金診断に成果報酬型広告を掲載しています。広告のあるページには冒頭とリンク付近に「PR」を表示します。広告以外の申込リンクは各社の公式サイトへ直接つながります。</p>
          <p className="mt-3">広告の有無だけで比較対象や掲載順を決めません。編集方針に変更が生じた場合は、このページを更新します。</p>
        </div>

        <div className="rounded-lg border border-accent-200 bg-accent-50 p-5 md:p-6">
          <h2 className="text-xl font-bold text-foreground-900">免責事項</h2>
          <p className="mt-3">当サイトの情報は、選択肢を整理するための一般的な情報です。情報の正確性・完全性・最新性を保証するものではありません。契約、購入、修理などの最終判断は、各サービスの公式条件をご確認のうえ、ご自身の責任で行ってください。</p>
          <p className="mt-3">当サイトの利用または掲載情報をもとにした判断によって生じた損害について、当サイトは法令上認められる範囲で責任を負いかねます。リンク先で提供される商品・サービスについては、各運営者の規約と案内が適用されます。</p>
        </div>

        <div className="flex flex-wrap gap-4 text-sm">
          <Link to="/about" className="font-semibold text-primary-500 hover:text-primary-600">この案内所について</Link>
          <Link to="/privacy" className="font-semibold text-primary-500 hover:text-primary-600">プライバシーポリシー</Link>
          <Link to="/contact" className="font-semibold text-primary-500 hover:text-primary-600">お問い合わせ</Link>
        </div>
        <p className="text-xs text-foreground-500">更新日：2026年9月23日</p>
      </section>
    </Layout>
  );
}
